import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/princemendiratta/Documents/startup/ws/tree-1/apps/frontend/src/features/sign-up/components/sign-up-client.tsx");
